import {
  LightColors as HygraphLightColor,
  Maybe as HygraphMaybe,
} from '@/lib/types';

import { LightColor } from '@/enums/light-color';

export default function lightColorTransformer(
  props: HygraphMaybe<HygraphLightColor> | undefined
) {
  switch (props) {
    case HygraphLightColor.Coral:
      return LightColor.CORAL;
    case HygraphLightColor.LightBlue:
      return LightColor.LIGHT_BLUE;
    case HygraphLightColor.LightPink:
      return LightColor.LIGHT_PINK;
    case HygraphLightColor.LightPurple:
      return LightColor.LIGHT_PURPLE;
    case HygraphLightColor.Orchid:
      return LightColor.ORCHID;
    case HygraphLightColor.Sky:
      return LightColor.SKY;
    case HygraphLightColor.White:
      return LightColor.WHITE;
    default:
      return undefined;
  }
}
